import { render } from "./FDButton.vue?vue&type=template&id=1b9847d2"
import script from "./FDButton.vue?vue&type=script&lang=js"
export * from "./FDButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__